import deleteIcon from "assets/images/icons/delete.svg";
import TrashIcon from "assets/images/icons/trash2.svg";
import ModalConditionalDomain from "components/ModalConditionalDomain";
import ModalConfirmationDomain from "components/ModalConditionalDomain/ModalConfirmationDomain";
import ModalPromoCode from "components/ModalPromoCode";
import ModalHostingNoDomain from "components/ModalHostingNoDomain";
import ToSCompanyCheckBox from "components/ToSCompanyCheckbox";
import {
  deletedWhois,
  getMyVoucher,
  removeCartItem,
  removePromoCode,
  setQueryPromo,
  clearCart,
  removeDomainBundle,
  // removeDomainForwarderFromCart,
  addPromoKaos,
  addPaymentGateway,
  removePpn,
  addConvenienceFee,
  addPaymentMethod,
} from "features/common/layouts/cartSlice";
import { checkLogin } from "features/common/auth/authSlice";
import { formatIDR } from "helpers/utils";
import { terminReadable } from "helpers/helper";
import CheckoutButton from "layouts/CheckoutButton";
import { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
// import summary from "../../assets/scss/CheckoutTable.module.scss"; // File sudah dihapus
import { useQuery } from "helpers/utils";
// import { isNoDomain } from "features/hosting/hostingSlice";
// import DiscountBadge from "components/DiscountBadge";
// import { paymentList } from "helpers/paymentmethod";

import {
  // notifyWarning,
  notifyError,
  // notifySuccess,
} from "components/ToastMessage";
import ModalLogin from "layouts/ModalLogin";
import ModalRegisterSimple from "layouts/ModalRegisterSimple";
import { calculateHemat, calculateHematFallback } from 'helpers/hematCalculator';

const CheckoutTable = (props) => {
  const {
    productsList: cartItems,
    total,
    paymentMethod,
    tax,
    promoCode,
    requirement,
    conditionalDomain,
    documentNpwp,
    existingDomain,
    orderProcessName,
    additionalFee,
    domainBundle,
  } = useSelector((state) => state.cart);
  const { data_login, status_login } = useSelector((state) => state.auth);
  const productGroup = useSelector((state) => state.hosting.products);
  const { rehydrated } = useSelector((state) => state._persist);
  const dispatch = useDispatch();
  
  // Get domain from register/transfer in cart for display
  const getDomainFromCart = () => {
    const registerDomain = cartItems.find(item => item.type === "register");
    const transferDomain = cartItems.find(item => item.type === "transfer");
    const existingDomainFromCart = cartItems.find(item => item.type === "domain-existing");
    
    if (registerDomain && registerDomain.domain) {
      return registerDomain.domain;
    } else if (transferDomain && transferDomain.domain) {
      return transferDomain.domain;
    } else if (existingDomainFromCart && existingDomainFromCart.domain) {
      return existingDomainFromCart.domain;
    } else if (existingDomain && existingDomain.domain) {
      return existingDomain.domain;
    }
    
    return null;
  };
  
  const cartDomain = getDomainFromCart();
  const location = useLocation();
  const navigate = useNavigate();
  const query = useQuery();
  const { isSummaryPage } = props;
  const date = new Date();


  const [typeHeader, setTypeHeader] = useState({
    domain: false,
    hosting: false,
    VPS: false,
    ssl: false,
    upgrade: false,
    renew: false,
    addon: false,
  });
  const [disabledNext, setDisabledNext] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [batasanBerlaku, setBatasanBerlaku] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showModalConfimation, setShowModalConfirmation] = useState(false);
  const [currentTld, setCurrentTld] = useState(null);
  const [currentSyarat, setCurrentSyarat] = useState(null);
  const [currentDomain, setCurrentDomain] = useState(null);
  const [isHostingOverride, setIsHostingOverride] = useState(false);
  const [modalIndex, setModalIndex] = useState(0);
  const [tldArr, setTldArr] = useState([]);
  const [domainConditional, setDomainConditional] = useState(false);
  const [isRemovePpn, setIsRemovePpn] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [showHostingNoDomainModal, setShowHostingNoDomainModal] = useState(false);
  const [internetOfferStatus, setInternetOfferStatus] = useState("Memeriksa...");

  const checkBillingCycle = cartItems[0]?.billingcycle ?? "monthly";

  const hasHosting = cartItems.some((item) => item.type === "hostingaccount");
  const hasDomain = cartItems.some(
    (item) =>
      item.type === "register" ||
      item.type === "transfer" ||
      item.type === "backorder-register" ||
      item.type === "backorder"
  );
  // const hasVPS = cartItems.some(item => item.type === "server");

  const isExistingDomainValid =
    existingDomain &&
    typeof existingDomain === "object" &&
    !!existingDomain.domain;

  useEffect(() => {
    if (rehydrated) {
      if (
        query.pid ||
        query.domainregister ||
        query.domainbackorder ||
        query.domaintransfer
      ) {
        const checkProduct = cartItems.find((list) => list.pid === +query.pid);

        const checkDomain = cartItems.find(
          (list) => list.domain === query.domainregister
        );

        const checkDomainBackorder = cartItems.find(
          (list) => list.domain === query.domainbackorder
        );

        const checkDomainTransfer = cartItems.find(
          (list) => list.domain === query.domaintransfer
        );

        if (
          promoCode.queryCode &&
          !query.promocode &&
          location.pathname !== "/orderhosting" &&
          location.pathname !== "/ordervps"
        ) {
          dispatch(setQueryPromo(null));
          dispatch(removePromoCode());
        }

        // Untuk halaman orderproduct, jangan clear cart jika hanya billing cycle yang berbeda
        if (location.pathname === "/orderproduct") {
          // Jika ada query.pid tapi produk tidak ada di cart, clear cart
          if (query.pid && !checkProduct) {
            dispatch(clearCart(orderProcessName));
          }
          // Jika tidak ada query.pid, tidak perlu clear cart
        } else {
          // Logic untuk halaman lain (domain, hosting, vps, dll)
          if (!checkProduct && query.pid) {
            dispatch(clearCart(orderProcessName));
          } else if (!checkDomain && query.domainregister) {
            dispatch(clearCart(orderProcessName));
          } else if (!checkDomainBackorder && query.domainbackorder) {
            dispatch(clearCart(orderProcessName));
          } else if (!checkDomainTransfer && query.domaintransfer) {
            dispatch(clearCart(orderProcessName));
          } else {
            return;
          }
        }
      }
    }
    // eslint-disable-next-line
  }, [rehydrated]);

  useEffect(() => {
    if (promoCode.priceOverrideHosting !== 0) {
      setIsHostingOverride(true);
    } else {
      setIsHostingOverride(false);
    }
  }, [promoCode.priceOverrideHosting]);

  useEffect(() => {
    if (query.promocode) {
      dispatch(setQueryPromo(query.promocode));
    }
  }, [query.promocode, dispatch]);

  useEffect(() => {
    if (
      location.pathname === "/paymentmethod" &&
      promoCode.queryCode &&
      orderProcessName !== "hosting" &&
      orderProcessName !== "vps" &&
      orderProcessName !== "server" &&
      orderProcessName !== "domain"
    ) {
      setModalShow(true);
      dispatch(getMyVoucher());
    }
  }, [location.pathname, promoCode.queryCode, dispatch, orderProcessName]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_API}apis/getBatasanBerlaku.php`)
      .then((data) => data.json())
      .then((val) => setBatasanBerlaku(val));
  }, []);

  useEffect(() => {
    if (data_login && data_login.client && data_login.client.country) {
      if (data_login.client.country !== "ID") {
        dispatch(removePpn());
        setIsRemovePpn(true);
        if (paymentMethod) {
          if (
            paymentMethod.label !== "Visa/Mastercard" &&
            paymentMethod.label !== "Paypal" &&
            paymentMethod.label !== "Stripe" &&
            paymentMethod.label !== "Wise"
          ) {
            dispatch(
              addConvenienceFee({
                label: "Paypal",
                price: 0,
                name: "Convenience Fee",
                type: "Additional Fee",
                fee: "Additional Fee",
                feetype: "",
                add: "0",
              })
            );
            dispatch(
              addPaymentMethod({
                label: "Paypal",
                value: "paypal",
              })
            );
          }
        }
      } else {
        setIsRemovePpn(false);
      }
    }
  }, [location.pathname, dispatch, data_login, cartItems, paymentMethod]);

  // Close login/register modals when user successfully logs in
  useEffect(() => {
    if (status_login) {
      setShowLoginModal(false);
      setShowRegisterModal(false);
      // Dispatch checkLogin to ensure data_login is properly updated
      dispatch(checkLogin());
    }
  }, [status_login, dispatch]);

  // Check internet offer status when user is logged in and on order summary page
  useEffect(() => {
    const checkInternetOfferStatus = async () => {
      if (status_login && data_login?.client && location.pathname === "/ordersummary") {
        const clientCity = data_login?.client?.city;
        const address1 = data_login?.client?.address1;
        const address2 = data_login?.client?.address2;
        const email = data_login?.client?.email;

        if (!clientCity || !address1 || !email) {
          setInternetOfferStatus("Tidak Tersedia");
          return;
        }

        try {
          const url = `${process.env.REACT_APP_BASE_API}order/apis/getAvailableNet.php?email=${email}&address1=${address1}&address2=${address2}&city=${encodeURIComponent(clientCity)}`;
          const response = await fetch(url);
          const data = await response.json();

          if (data.code === 200) {
            setInternetOfferStatus("Tersedia");
            // Notify CheckoutButton that internet is available
            window.dispatchEvent(new CustomEvent('updateInternetOfferStatus', {
              detail: { status: 'Tersedia' }
            }));
          } else if (data.code === 500) {
            if (data.debug?.status === 'Done') {
              setInternetOfferStatus("Sudah Dikirim");
              window.dispatchEvent(new CustomEvent('updateInternetOfferStatus', {
                detail: { status: 'Sudah Dikirim' }
              }));
            } else if (data.debug?.status === 'Skip') {
              setInternetOfferStatus("Dilewati");
              window.dispatchEvent(new CustomEvent('updateInternetOfferStatus', {
                detail: { status: 'Dilewati' }
              }));
            } else {
              setInternetOfferStatus("Tidak Tersedia");
              window.dispatchEvent(new CustomEvent('updateInternetOfferStatus', {
                detail: { status: 'Tidak Tersedia' }
              }));
            }
          } else {
            setInternetOfferStatus("Tidak Tersedia");
            window.dispatchEvent(new CustomEvent('updateInternetOfferStatus', {
              detail: { status: 'Tidak Tersedia' }
            }));
          }
        } catch (error) {
          console.error("Error checking internet offer status:", error);
          setInternetOfferStatus("Tidak Tersedia");
          window.dispatchEvent(new CustomEvent('updateInternetOfferStatus', {
            detail: { status: 'Tidak Tersedia' }
          }));
        }
      } else {
        setInternetOfferStatus("Tidak Tersedia");
        window.dispatchEvent(new CustomEvent('updateInternetOfferStatus', {
          detail: { status: 'Tidak Tersedia' }
        }));
      }
    };

    checkInternetOfferStatus();
  }, [status_login, data_login, location.pathname]);

  // Listen for internet offer status updates from ModalNetInstallation
  useEffect(() => {
    const handleStatusUpdate = (event) => {
      try {
        setInternetOfferStatus(event.detail.status);
      } catch (error) {
        console.warn("Error handling internet offer status update:", error);
      }
    };

    window.addEventListener('updateInternetOfferStatus', handleStatusUpdate);
    return () => {
      try {
        window.removeEventListener('updateInternetOfferStatus', handleStatusUpdate);
      } catch (error) {
        console.warn("Error removing internet offer status listener:", error);
      }
    };
  }, []);

  // Global error boundary for DOM manipulation errors
  useEffect(() => {
    const handleGlobalError = (event) => {
      if (event.error && event.error.message && 
          (event.error.message.includes('removeChild') || 
           event.error.message.includes('appendChild') ||
           event.error.message.includes('insertBefore'))) {
        console.warn('DOM manipulation error caught and handled in CheckoutTable:', event.error.message);
        event.preventDefault();
        return false;
      }
    };

    const handleUnhandledRejection = (event) => {
      if (event.reason && event.reason.message && 
          (event.reason.message.includes('removeChild') || 
           event.reason.message.includes('appendChild') ||
           event.reason.message.includes('insertBefore'))) {
        console.warn('DOM manipulation promise rejection caught and handled in CheckoutTable:', event.reason.message);
        event.preventDefault();
        return false;
      }
    };

    window.addEventListener('error', handleGlobalError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('error', handleGlobalError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  useEffect(() => {
    if (batasanBerlaku) {
      let tldArr = [];

      cartItems.forEach((item) => {
        if (item.domain) {
          let tld = item.domain.split(".");
          let tldString;
          if (tld.length > 2) {
            tldString = "." + tld[1] + "." + tld[2];
          } else {
            tldString = "." + tld[1];
          }

          if (
            batasanBerlaku.find(
              (batasan) =>
                batasan.extension === tldString &&
                batasan.extension !== ".web.id"
            )
          ) {
            setDomainConditional(true);
            const syarat = batasanBerlaku.find(
              (batasan) => batasan.extension === tldString
            );
            tldArr.push({
              tld: tldString,
              syarat: syarat.batasanberlaku,
              domain: item.domain,
            });
          }
        }
      });
      if (tldArr.length > 0) {
        setCurrentTld(tldArr[0].tld);
        setCurrentSyarat(tldArr[0].syarat);
        setCurrentDomain(tldArr[0].domain);
        setShowModal(true);
      }
      setTldArr(tldArr);
    }
  }, [batasanBerlaku, cartItems]);

  const handlerCloseModalConfirmation = (e) => {
    e.preventDefault();
    setShowModalConfirmation(false);
  };

  useEffect(() => {
    if (cartItems.length !== 0) {
      setDisabledNext(false);
      cartItems.forEach((item) => {
        if (item.domain) {
          setTypeHeader((prev) => ({ ...prev, domain: true }));
        }
        if (item.type === "hostingaccount") {
          setTypeHeader((prev) => ({ ...prev, hosting: true }));
        }
        if (item.type === "server") {
          setTypeHeader((prev) => ({ ...prev, VPS: true }));
        }
        if (item.type === "emailSuite") {
          setTypeHeader((prev) => ({ ...prev, emailSuite: true }));
        }
        if (item.pid === 81) {
          setTypeHeader((prev) => ({ ...prev, digitalSignature: true }));
        }
        if (item.type === "vpn") {
          setTypeHeader((prev) => ({ ...prev, diegoVpn: true }));
        }
        if (item.type === "ssl") {
          setTypeHeader((prev) => ({ ...prev, ssl: true }));
        }
        if (item.type === "upgrade") {
          setTypeHeader((prev) => ({ ...prev, upgrade: true }));
        }
        if (item.type === "renew") {
          setTypeHeader((prev) => ({ ...prev, renew: true }));
        }
        if (item.type === "addon") {
          setTypeHeader((prev) => ({ ...prev, addon: true }));
        }
      });

      // Cek kondisi hosting tanpa domain dengan billing cycle < 1 tahun
      const hasHosting = cartItems.some(item => item.type === "hostingaccount");
      const hasDomain = cartItems.some(item =>
        item.type === "register" ||
        item.type === "transfer" ||
        item.type === "backorder-register" ||
        item.type === "backorder"
      );

      if (hasHosting && !hasDomain && !isExistingDomainValid && status_login) {
        const hostingItems = cartItems.filter(item => item.type === "hostingaccount");
        const hasShortTermHosting = hostingItems.some(item =>
          item.billingcycle === "monthly" ||
          item.billingcycle === "quarterly" ||
          item.billingcycle === "semiannually"
        );

        // Hanya disable jika di halaman payment method dan ada short term hosting
        if (hasShortTermHosting && location.pathname === "/paymentmethod") {
          setDisabledNext(true);
        } else {
          setDisabledNext(false);
        }
      } else {
        setDisabledNext(false);
      }
    } else {
      setDisabledNext(true);
    }
  }, [cartItems, location.pathname, isExistingDomainValid, status_login]);

  useEffect(() => {
    if (location.pathname === "/paymentmethod" && !requirement.tos)
      setDisabledNext(true);
    if (requirement.tos && cartItems.length !== 0) {
      setDisabledNext(false);
    }
  }, [location, requirement, cartItems]);

  // Tambahan logic untuk memastikan tombol aktif di paymentmethod jika semua requirement terpenuhi
  useEffect(() => {
    if (location.pathname === "/paymentmethod") {
      // Jika ada cart items dan ToS sudah dicentang, enable tombol
      if (cartItems.length > 0 && requirement.tos) {
        setDisabledNext(false);
      } else if (cartItems.length === 0) {
        setDisabledNext(true);
      } else if (!requirement.tos) {
        setDisabledNext(true);
      }
    }
  }, [location.pathname, cartItems.length, requirement.tos]);

  const removeItem = (e, pid, domain, whois, serviceid) => {
    if (pid) {
      dispatch(removeCartItem(pid));
    } else if (domain) {
      dispatch(removeCartItem(domain));
    } else if (whois) {
      dispatch(removeCartItem(whois));
      dispatch(deletedWhois(whois));
    } else if (serviceid) {
      dispatch(removeCartItem(serviceid));
    }
  };

  // const VAValues = new Set(paymentList.VAList.map((item) => item.value));

  const navigateRoute = (e) => {
    e.preventDefault();

    if (cartItems.length === 0) {
      notifyError("Keranjang belanja kosong!");
      return;
    }

    // Cek apakah ada produk hosting dan domain
    const hasHosting = cartItems.some(item => item.type === "hostingaccount");
    const hasHostingReseller = cartItems.some(item => item.type === "reselleraccount");
    const hasDomain = cartItems.some(item =>
      item.type === "register" ||
      item.type === "transfer" ||
      item.type === "backorder-register" ||
      item.type === "backorder"
    );
    const isOrderDomain = location.pathname === "/orderdomain";
    const isOrderVPS = location.pathname === "/ordervps";
    const isOrderServer = location.pathname === "/orderserver";
    const isOrderDiegoVPN = location.pathname === "/orderdiegovpn";
    const isOrderSSL = location.pathname === "/orderssl";
    const isOrderAddon = location.pathname === "/addon";
    // Cek VPS di cart (termasuk Managed VPS dengan PID 1167-1170)
    // Managed VPS juga memiliki type === "server", jadi akan terdeteksi oleh hasVPS
    const hasVPS = cartItems.some(item => item.type === "server");
    const hasExistingDomain = isExistingDomainValid;
    const hasVPN = cartItems.some(item => item.type === "vpn");
    const hasBackorder = cartItems.some(item => item.type === "backorder" || item.type === "backorder-register");
    const hasSSL = cartItems.some(item => item.type === "ssl");
    const hasOtherProduct = cartItems.some(item => item.type === "other");
    const hasUpgrade = cartItems.some(item => item.type === "upgrade");
    const hasRenew = cartItems.some(item => item.type === "renew");
    const hasAddon = cartItems.some(item => item.type === "addon");

    // Jika di halaman ordervps, cek VPS (termasuk Managed VPS)
    if (isOrderVPS) {
      // Managed VPS PID: 1167, 1168, 1169, 1170
      const managedVpsPids = [1167, 1168, 1169, 1170];
      
      // Cek apakah ada VPS di cart
      // - VPS biasa memiliki type === "server"
      // - Managed VPS juga memiliki type === "server" ATAU bisa dicek berdasarkan PID
      const hasVPSInCart = cartItems.some(item => 
        item.type === "server" || managedVpsPids.includes(item.pid)
      );
      
      // Jika tidak ada VPS di cart (baik VPS biasa maupun Managed VPS)
      if (!hasVPSInCart) {
        notifyError("Silahkan pilih VPS terlebih dahulu!");
        return;
      }
      
      navigate("/paymentmethod");
      return;
    }
    // Jika di halaman orderserver, hanya cek Server
    if (isOrderServer) {
      if (!hasVPS) {
        notifyError("Silahkan pilih Server terlebih dahulu!");
        return;
      }
      navigate("/paymentmethod");
      return;
    }
    // Jika di halaman orderssl, hanya cek SSL
    if (isOrderSSL) {
      if (!hasSSL) {
        notifyError("Silahkan pilih produk SSL terlebih dahulu!");
        return;
      }
      navigate("/paymentmethod");
      return;
    }

    // Jika di halaman orderdiegovpn, hanya cek VPN
    if (isOrderDiegoVPN) {
      if (!hasVPN && location.pathname !== "/paymentmethod") {
        notifyError("Silahkan pilih produk VPN terlebih dahulu!");
        return;
      }
      navigate("/paymentmethod");
      return;
    }

    // Jika di halaman orderdomain, hanya cek domain/backorder
    if (isOrderDomain) {
      if (!hasDomain && !hasExistingDomain && !hasBackorder) {
        notifyError("Silahkan pilih domain terlebih dahulu!");
        return;
      }
      navigate("/paymentmethod");
      return;
    }

    // Jika di halaman orderproduct, cek produk other
    if (location.pathname === "/orderproduct") {
      if (!hasOtherProduct) {
        notifyError("Silahkan pilih produk terlebih dahulu!");
        return;
      }
      navigate("/paymentmethod");
      return;
    }

    // Jika di halaman renew, cek produk renew
    if (location.pathname === "/renew") {
      if (!hasRenew) {
        notifyError("Silahkan pilih layanan untuk diperpanjang!");
        return;
      }
      navigate("/paymentmethod");
      return;
    }

    // Jika di halaman addon, cek produk addon
    if (isOrderAddon) {
      if (!hasAddon) {
        notifyError("Silahkan pilih addon terlebih dahulu!");
        return;
      }
      navigate("/paymentmethod");
      return;
    }

    // Jika ada domain tapi tidak ada hosting (bukan reseller), maka disable
    // Skip pengecekan ini jika sudah di halaman payment method
    if (hasDomain && !hasHosting && location.pathname !== "/paymentmethod") {
      // Skip pengecekan hosting jika ini adalah domain backorder
      if (hasBackorder) {
        navigate("/paymentmethod");
        return;
      }

      // Jika hanya ada domain tanpa hosting, langsung ke /paymentmethod
      navigate("/paymentmethod");
      return;
    }

    // Jika ada hosting tanpa domain, cek apakah sudah login
    if (hasHosting && !hasDomain && !hasExistingDomain && location.pathname !== "/paymentmethod") {
      if (!status_login) {
        setShowLoginModal(true);
        // notifyError("Untuk pembelian hosting tanpa domain, Anda harus login terlebih dahulu!");
        return;
      }

      // Jika sudah login, cek billing cycle - jika < 1 tahun maka wajib ada domain
      const hostingItems = cartItems.filter(item => item.type === "hostingaccount");
      const hasShortTermHosting = hostingItems.some(item =>
        item.billingcycle === "monthly" ||
        item.billingcycle === "quarterly" ||
        item.billingcycle === "semiannually"
      );

      if (hasShortTermHosting) {
        notifyError("Produk hosting membutuhkan domain!");
        return;
      }

      // Tampilkan modal konfirmasi hosting tanpa domain
      setShowHostingNoDomainModal(true);
      return;
    }

    // Jika tidak ada produk sama sekali, maka disable
    if (!hasHosting && !hasHostingReseller && !hasDomain && !hasExistingDomain && !hasVPS && !hasSSL && !hasVPN && !hasOtherProduct && !hasUpgrade && !hasRenew && !hasAddon && location.pathname !== "/paymentmethod") {
      notifyError("Silahkan pilih produk terlebih dahulu!");
      return;
    }

    // Jika di halaman paymentmethod, arahkan ke ordersummary
    if (location.pathname === "/paymentmethod") {
      navigate("/ordersummary");
    } else {
      // Jika tidak di paymentmethod, arahkan ke paymentmethod
      navigate("/paymentmethod");
    }
  };

  const promoModalHandler = () => {
    setModalShow(true);
    dispatch(getMyVoucher());
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalIndex(modalIndex + 1);

    if (modalIndex + 1 < tldArr.length) {
      setCurrentTld(tldArr[modalIndex + 1].tld);
      setCurrentSyarat(tldArr[modalIndex + 1].syarat);
      setCurrentDomain(tldArr[modalIndex + 1].domain);
      setShowModal(true);
    } else if (!conditionalDomain.label) {
      setShowModalConfirmation(true);
      setShowModal(false);
    }
  };

  const removePromoHandle = () => {
    dispatch(removePromoCode());
  };

  const removeBundleItem = () => {
    dispatch(removeDomainBundle());
  };

  const removeCustomPromo = () => {
    dispatch(addPromoKaos({ promoKaos: "" }));
  };

  const removePaymentGateway = () => {
    dispatch(addPaymentGateway({ paymentGateway: "" }));
  };

  // Handler for hosting no domain modal
  const handleHostingNoDomainConfirm = () => {
    setShowHostingNoDomainModal(false);
    navigate("/paymentmethod");
  };

  const handleHostingNoDomainCancel = () => {
    setShowHostingNoDomainModal(false);

    // Show domain sections and focus on domain input field when user clicks "Tidak"
    setTimeout(() => {
      try {
        // Trigger a custom event to show domain sections
        window.dispatchEvent(new CustomEvent('showDomainSections'));

        // Wait for DOM to update and then focus on domain input field
        setTimeout(() => {
          try {
            const domainInput = document.getElementById("searchDomain");
            if (domainInput && domainInput.parentNode) {
              domainInput.focus();
              domainInput.scrollIntoView({ behavior: "smooth", block: "center" });
            }
          } catch (error) {
            console.warn("Error focusing domain input:", error);
          }
        }, 200); // Increased delay to ensure DOM is updated
      } catch (error) {
        console.warn("Error showing domain sections:", error);
      }
    }, 100);
  };

  // const handleRemoveForwardDomain = (domain) => {
  //   dispatch(removeDomainForwarderFromCart({ domain }));
  // };

  useEffect(() => {
    if (conditionalDomain) {
      if (conditionalDomain.label) {
        setShowModalConfirmation(false);
      } else if (conditionalDomain.isSkipAll) {
        setShowModalConfirmation(true);
      }
    }
  }, [conditionalDomain]);

  const getHematAmount = (item) => {
    // Gunakan monthlyPrice dari item cart jika tersedia (dari HostingProductSelectorNew)
    // atau ambil dari productGroup untuk PID 1124-1143
    const monthlyPrice = item.monthlyPrice ||
      ((item.pid >= 1124 && item.pid <= 1143)
        ? productGroup?.find(p => p.pid === item.pid)?.pricing?.IDR?.monthly
        : null);

    // Gunakan calculateHemat
    const { hematAmount } = calculateHemat(
      item.pid,
      item.billingcycle,
      item.price,
      monthlyPrice
    );

    if (hematAmount > 0) {
      return hematAmount;
    }

    // Fallback ke perhitungan static
    const { hematAmount: fallbackHemat } = calculateHematFallback(
      item.pid,
      item.billingcycle,
      item.price
    );

    return fallbackHemat;
  };

  const getOriginalPrice = (item) => {
    // Gunakan monthlyPrice dari item cart jika tersedia (dari HostingProductSelectorNew)
    // atau ambil dari productGroup untuk PID 1124-1143
    const monthlyPrice = item.monthlyPrice ||
      ((item.pid >= 1124 && item.pid <= 1143)
        ? productGroup?.find(p => p.pid === item.pid)?.pricing?.IDR?.monthly
        : null);

    // Gunakan calculateHemat
    const { originalPrice } = calculateHemat(
      item.pid,
      item.billingcycle,
      item.price,
      monthlyPrice
    );

    if (originalPrice) {
      return originalPrice;
    }

    // Fallback ke perhitungan static
    const { originalPrice: fallbackOriginal } = calculateHematFallback(
      item.pid,
      item.billingcycle,
      item.price
    );

    return fallbackOriginal;
  };

  const PromoItem = ({
    label,
    price,
    onRemove,
    isFree = false,
    description,
  }) => (
    <tr>
      <td width="25%">
        <label className="fw-bold align-self-center">{label}</label>
        {description && (
          <div className="mt-1">
            {description}
          </div>
        )}
      </td>
      <td width="75%">
        <div className="product-price fw-bold">
          <div className="d-flex align-items-center justify-content-end">
            <div className="d-flex flex-column">
              {isFree ? (
                <>
                  <s className="text-muted">+ {formatIDR(50000)}</s>
                  <span className="badge bg-warning ms-2">GRATIS!</span>
                </>
              ) : (
                <>
                  <s
                    className="text-secondary text-center fw-bold align-self-end"
                    style={{ fontSize: "16px" }}
                  >
                    {price}
                  </s>
                  <p className="text-qw-primary mb-0">GRATIS</p>
                </>
              )}
            </div>
            <div className="vr mx-2"></div>
            <button className="btn btn-link p-0 m-0" onClick={onRemove}>
              <img src={TrashIcon} alt="trash.svg" />
            </button>
          </div>
        </div>
      </td>
    </tr>
  );

  return (
    <>
      <div className="checkout-table d-flex flex-column flex-wrap">
        <div className="d-flex justify-content-between">
          <h5 className="fw-bold text-qw-primary">Ringkasan Belanja</h5>
        </div>
        <div
          className="table-item table-responsive pe-1"
        >
          {cartItems.length === 0 && (
            <div className="small mb-0 text-center text-muted mt-3">
              Tidak ada item
            </div>
          )}
          {cartItems.length > 0 && (
            <>
              <table
                className="table"
                style={{ tableLayout: "fixed" }}
                id="cart-container"
              >
                {cartItems.map((item, i) => (
                  <tbody key={i}>
                    <tr>
                      <th className="ps-0 pb-0 border-0 fw-normal" colSpan={2}>
                        {item.type === "register" && (
                          <label className="mb-0">
                            {typeHeader.domain && "Domain"} Baru -{" "}
                            <strong>
                              {item.duration} <span>Tahun</span>
                            </strong>
                          </label>
                        )}

                        {item.type === "backorder-register" && (
                          <label className="mb-0">
                            {typeHeader.domain && "Domain"} Baru -{" "}
                            <strong>
                              {item.duration} <span>Tahun</span>
                            </strong>
                          </label>
                        )}

                        {item.type === "transfer" && (
                          <label className="mb-0">
                            {typeHeader.domain && "Domain"} Transfer
                          </label>
                        )}

                        {item.type === "backorder" && (
                          <label className="mb-2">
                            {typeHeader.domain && "Domain"} Backorder
                          </label>
                        )}

                        {item.type === "emailSuite" && (
                          <label className="mb-1">
                            {"Jumlah Akun x"}
                            {item.configoptions && item.configoptions.length > 0
                              ? item.configoptions[0].value
                              : 1}
                          </label>
                        )}

                        {item.pid === 1146 && (
                          <label className="mb-1">
                            {"Jumlah x"}
                            {item.configoptions && item.configoptions[0]
                              ? item.configoptions[0].value + 1
                              : 1}
                          </label>
                        )}

                        {item.pid === 1157 && (
                          <label className="mb-1">
                            {"Jumlah x"}
                            {item.configoptions && item.configoptions[0]
                              ? item.configoptions[0].value + 1
                              : 1}
                          </label>
                        )}

                        {item.pid === 81 && (
                          <label className="mb-0">
                            {typeHeader.digitalSignature &&
                              "Layanan Digital Signature"}
                          </label>
                        )}

                        {item.type === "vpn" && (
                          <label className="mb-2">
                            {"Jumlah User x"}
                            {item.account}
                          </label>
                        )}

                        {item.type === "hostingaccount" && (
                          <label className="mb-0">
                            {typeHeader.hosting && "Layanan Hosting"}
                          </label>
                        )}

                        {item.type === "reselleraccount" && (
                          <label className="mb-0">
                            {typeHeader.hosting && "Layanan Hosting"}
                          </label>
                        )}

                        {item.type === "server" && (
                          <label className="mb-0">
                            {typeHeader.VPS && "Layanan Server"}
                          </label>
                        )}

                        {item.type === "ssl" && (
                          <label className="mb-0">
                            {typeHeader.ssl && "SSL"}
                          </label>
                        )}

                        {item.type === "upgrade" && (
                          <label className="mb-0">
                            {typeHeader.upgrade && "Upgrade Service"}
                          </label>
                        )}

                        {item.type === "renew" && (
                          <label className="mb-0">
                            {typeHeader.renew && "Perpanjangan Layanan"}
                            {item.renewType === "hosting" ? " - Hosting" : " - Domain"}
                          </label>
                        )}

                        {item.type === "addon" && (
                          <label className="mb-0">
                            {typeHeader.addon && "Addon Layanan"}
                          </label>
                        )}
                      </th>
                    </tr>
                    <tr>
                      <td width="25%">
                        <div
                          className="product-name fw-bold text-truncate"
                          title={`${item.name} ${item.hostname ? `(${item.hostname})` : ""
                            }`}
                        >
                          {item.name}
                        </div>

                        {item?.hostname && (
                          <div className="small fw-normal text-muted">
                            Hostname: <strong>{item.hostname}</strong>
                          </div>
                        )}

                        {/* Base VPS Info untuk Custom VPS */}
                        {item.name && item.name.includes('Custom VPS') && (
                          <div className="small text-muted mt-1">
                            <div className="fw-semibold text-dark mb-1">Base VPS:</div>
                            <div className="ms-2">
                              <div>• 2 Core CPU</div>
                              <div>• 2GB RAM</div>
                              <div>• 20GB Storage</div>
                            </div>
                          </div>
                        )}
                        <div className="d-flex flex-row">
                          <div className="text-qw-primary small align-self-center me-2">
                            {item.pid === 1157
                              ? "14 Hari (Trial)"
                              : item.pid === 81
                                ? item.duration === "annually"
                                  ? "1 tahun"
                                  : item.duration === "biennially"
                                    ? "2 tahun"
                                    : item.duration === "triennially"
                                      ? "3 tahun"
                                      : item.duration
                              : item.type === "emailSuite"
                                ? item.duration === "monthly"
                                  ? "1 bulan"
                                  : item.duration === "semiannually"
                                    ? "6 bulan"
                                    : item.duration === "annually"
                                      ? "1 tahun"
                                      : item.duration === "biennially"
                                        ? "2 tahun"
                                        : item.duration === "triennially"
                                          ? "3 tahun"
                                          : item.duration
                                : item.type === "renew"
                                  ? "" // Tidak tampilkan billing cycle untuk semua renew items (akan ditampilkan di bagian renew detail)
                                  : item.type === "addon"
                                    ? (item.billingcycle === "onetime" ? "Sekali Bayar" : terminReadable(item?.billingcycle))
                                    : terminReadable(item?.billingcycle)}
                          </div>

                          {item.type === "hostingaccount" &&
                            !isHostingOverride &&
                            (() => {
                              const hematAmount = getHematAmount(item);
                              return hematAmount > 0 ? (
                                <p
                                  className="text-white text-center py-1 fw-bold px-2 mb-0"
                                  style={{
                                    backgroundColor: "#ee4d30",
                                    maxWidth: "300px",
                                    borderRadius: "20px",
                                    fontSize: "12px",
                                    lineHeight: "1.2"
                                  }}
                                >
                                  Hemat {formatIDR(hematAmount)}
                                </p>
                              ) : null;
                            })()}
                        </div>

                        {item.type === "register" && item.price !== 0 && (
                          <small className="text-muted">
                            *Harga berlaku untuk pembelian pertama
                            <OverlayTrigger
                              placement={"right"}
                              overlay={
                                <Tooltip>
                                  Anda Akan dikenakan biaya perpanjangan sebesar{" "}
                                  {formatIDR(item.priceRenew)} tiap 1 tahun
                                </Tooltip>
                              }
                            >
                              <span
                                className="d-inline-block px-2 py-0 ms-1 fw-bold text-white"
                                style={{
                                  backgroundColor: "#959595",
                                  cursor: "pointer",
                                  borderRadius: "50%",
                                  fontSize: "12px",
                                }}
                              >
                                i
                              </span>
                            </OverlayTrigger>
                          </small>
                        )}

                        {item.type === "hostingaccount" && existingDomain && (
                          <small className="text-muted">
                            {existingDomain.domain}
                          </small>
                        )}

                        {item.type === "reselleraccount" && existingDomain && (
                          <small className="text-muted">
                            {existingDomain.domain}
                          </small>
                        )}

                        {item.type === "emailSuite" && cartDomain && (
                          <small className="text-muted">
                            {cartDomain}
                          </small>
                        )}

                        {item.type === "server" && existingDomain && (
                          <small className="text-muted">
                            {existingDomain.domain}
                          </small>
                        )}

                        {item.type === "whois" && (
                          <small className="text-muted">
                            {item.domainWhois}
                          </small>
                        )}

                        {item.type === "upgrade" && item.upgradeDetails && (
                          <small className="text-muted">
                            {/* Service ID: {item.serviceid} | */}
                            Dari: {item.upgradeDetails.fromProduct} → Ke: {item.upgradeDetails.toProduct} |
                            {/* Sisa: {item.upgradeDetails.remainingDays} hari */}
                          </small>
                        )}

                        {item.type === "renew" && (
                          <small className="text-muted">
                            {item.renewType === "hosting" ? (
                              <>
                                {item.domain && (
                                  <>
                                    {item.domain}
                                    <br />
                                  </>
                                )}
                                <span className="text-qw-primary fw-bold">
                                  {item.selectedBillingCycle && item.selectedBillingCycle !== item.billingcycle ?
                                    (() => {
                                      const oldCycle = item.billingcycle;
                                      const newCycle = item.selectedBillingCycle;
                                      const getTerminLabel = (cycle) => {
                                        const normalizedCycle = cycle?.toLowerCase();
                                        switch (normalizedCycle) {
                                          case 'monthly': return '1 Bulan';
                                          case 'quarterly': return '3 Bulan';
                                          case 'semiannually': return '6 Bulan';
                                          case 'annually': return '1 Tahun';
                                          case 'biennially': return '2 Tahun';
                                          case 'triennially': return '3 Tahun';
                                          default: return cycle;
                                        }
                                      };
                                      return `${getTerminLabel(oldCycle)} → ${getTerminLabel(newCycle)}`;
                                    })() :
                                    (() => {
                                      const cycle = item.billingcycle;
                                      const normalizedCycle = cycle?.toLowerCase();
                                      switch (normalizedCycle) {
                                        case 'monthly': return '1 Bulan';
                                        case 'quarterly': return '3 Bulan';
                                        case 'semiannually': return '6 Bulan';
                                        case 'annually': return '1 Tahun';
                                        case 'biennially': return '2 Tahun';
                                        case 'triennially': return '3 Tahun';
                                        default: return cycle;
                                      }
                                    })()
                                  }
                                </span>
                              </>
                            ) : (
                              <>
                                <span className="text-qw-primary fw-bold">
                                  {item.selectedPeriod && item.selectedPeriod !== (item.period || 1) ?
                                    `${item.period || 1} tahun → ${item.selectedPeriod} tahun` :
                                    `${item.period || 1} tahun`
                                  }
                                </span>
                              </>
                            )}
                          </small>
                        )}

                        {item.type === "Premium Domain" && (
                          <small className="text-muted">
                            {item.premium_domain}
                          </small>
                        )}

                        {item.type === "addon" && item.currentService && (
                          <small className="text-muted">
                            Service ID: {item.serviceid} | {item.currentService.name || item.currentService.productname}
                            {item.currentService.domain && ` (${item.currentService.domain})`}
                          </small>
                        )}

                        {item.type === "ssl" && item.customfields && Array.isArray(item.customfields) && (() => {
                          // Cari customfield yang value-nya adalah domain (FQDN)
                          // Domain biasanya adalah string yang mengandung titik, tidak mengandung @, dan bukan email
                          const domainField = item.customfields.find(field => {
                            if (!field || !field.value) return false;
                            
                            const value = String(field.value).trim();
                            
                            // Skip jika value adalah email (mengandung @)
                            if (value.includes('@')) return false;
                            
                            // Skip jika value adalah pilihan www
                            if (value === 'www' || value === 'tanpa www') return false;
                            
                            // Skip jika value mengandung kata-kata yang bukan domain
                            if (value.includes('Operating System') || 
                                value.includes('Email') || 
                                value.includes('CSR') ||
                                value.includes('Control Panel')) return false;
                            
                            // Domain harus mengandung titik dan minimal 2 karakter setelah titik
                            const domainPattern = /^[a-zA-Z0-9][a-zA-Z0-9-_.]*\.[a-zA-Z]{2,}$/;
                            return domainPattern.test(value);
                          });
                          
                          const domainValue = domainField?.value;
                          
                          return domainValue ? (
                            <small className="text-muted">
                              Domain: <strong>{domainValue}</strong>
                            </small>
                          ) : null;
                        })()}

                        {item.type === "backorder-register" &&
                          item.price !== 0 && (
                            <small className="text-muted">
                              *Harga berlaku untuk pembelian pertama
                              <OverlayTrigger
                                placement={"right"}
                                overlay={
                                  <Tooltip>
                                    Anda Akan dikenakan biaya perpanjangan
                                    sebesar {formatIDR(item.priceRenew)} tiap 1
                                    tahun
                                  </Tooltip>
                                }
                              >
                                <span
                                  className="d-inline-block px-2 py-0 ms-1 fw-bold text-white"
                                  style={{
                                    backgroundColor: "#959595",
                                    cursor: "pointer",
                                    borderRadius: "50%",
                                    fontSize: "12px",
                                  }}
                                >
                                  i
                                </span>
                              </OverlayTrigger>
                            </small>
                          )}
                      </td>
                      <td width="75%">
                        <div className="product-price">
                          <div className="d-flex align-items-center justify-content-end">
                            <div>
                              {item.price === 0 ? (
                                <span className="mb-0 text-qw-primary fw-bold">
                                  GRATIS
                                </span>
                              ) : (
                                <div className="d-flex flex-column align-items-end">
                                  {item.pid && !isHostingOverride && item.type !== "upgrade" && (() => {
                                    const originalPrice = getOriginalPrice(item);
                                    const hematAmount = getHematAmount(item);
                                    // Hanya tampilkan harga coret jika ada hemat dan originalPrice > item.price
                                    return originalPrice && hematAmount > 0 && originalPrice > item.price ? (
                                      <s
                                        className="text-secondary text-center fw-bold"
                                        style={{ fontSize: "16px" }}
                                      >
                                        {formatIDR(originalPrice)}
                                      </s>
                                    ) : null;
                                  })()}
                                  <span className="mb-0 fw-bold">
                                    {item.type === "renew" ? (
                                      // Renew items - show price only once
                                      item.price === 0 ? (
                                        <span className="text-success fw-bold">GRATIS</span>
                                      ) : (
                                        formatIDR(item.price)
                                      )
                                    ) : item.type === "register" ? (
                                      // Domain register items
                                      <>
                                        {date >= new Date("2023-12-31T17:00:00") ? (
                                          <>
                                            {(() => {
                                              const domainParts = item.domain.split(".");
                                              const isTwoLevelDomain = domainParts.length === 2;
                                              const tld = isTwoLevelDomain ? domainParts[1] : "";

                                              return (
                                                <>
                                                  {item.duration > 1 ? (
                                                    isTwoLevelDomain ? (
                                                      tld === "ai" ? (
                                                        formatIDR(item.price)
                                                      ) : (
                                                        formatIDR(item.price)
                                                      )
                                                    ) : (
                                                      formatIDR(item.priceRenew)
                                                    )
                                                  ) : (
                                                    <>
                                                      {item.isDonut ? (
                                                        <>
                                                          {item.priceRenew === item.price ? (
                                                            formatIDR(item.price)
                                                          ) : (
                                                            <div className="d-flex flex-column">
                                                              <s className="text-muted">
                                                                {formatIDR(item.price)}
                                                              </s>
                                                              {formatIDR(item.price)}
                                                            </div>
                                                          )}
                                                        </>
                                                      ) : (
                                                        formatIDR(item.price)
                                                      )}
                                                    </>
                                                  )}
                                                </>
                                              );
                                            })()}
                                          </>
                                        ) : (
                                          <>
                                            {(() => {
                                              const domainParts = item.domain.split(".");
                                              const tld = domainParts[1];
                                              const sldLength = domainParts[0].length;
                                              const totalPrice = item.duration > 1
                                                ? item.price * item.duration
                                                : item.price;
                                              const totalPriceID = item.duration > 1
                                                ? item.price * item.duration
                                                : 110000;

                                              return (
                                                <>
                                                  {tld !== "id" && (
                                                    <>{formatIDR(totalPrice)}</>
                                                  )}
                                                  {tld === "id" && sldLength > 4 && (
                                                    <>{formatIDR(totalPriceID)}</>
                                                  )}
                                                  {tld === "id" && sldLength < 5 && (
                                                    <>{formatIDR(totalPrice)}</>
                                                  )}
                                                </>
                                              );
                                            })()}
                                          </>
                                        )}
                                      </>
                                    ) : item.type === "domainWhois" ? (
                                      // Domain whois items
                                      <>
                                        {item.freeWhois ? (
                                          <>
                                            <div className="d-flex flex-column align-items-end">
                                              <s className="text-muted small text-decoration-line-through fw-bold">
                                                + {formatIDR(30000)}
                                              </s>
                                              <span className="badge bg-warning text-dark p-2 mt-1">GRATIS!</span>
                                            </div>
                                          </>
                                        ) : (
                                          <>+ {formatIDR(item.price)}</>
                                        )}
                                      </>
                                    ) : item.type === "upgrade" ? (
                                      // Upgrade items - show only the upgrade price (already prorated)
                                      formatIDR(item.price)
                                    ) : item.type === "transfer" || item.type === "backorder" || item.type === "backorder-register" ? (
                                      // Transfer, backorder items
                                      formatIDR(item.price)
                                    ) : (
                                      // Default case for other items (hosting, server, etc.)
                                      <>
                                        {!item.domain && !item.domainWhois && formatIDR(item.price)}
                                      </>
                                    )}
                                  </span>
                                </div>
                              )}
                            </div>
                            {item.fee ? (
                              ""
                            ) : (
                              <>
                                <div className="vr mx-2"></div>
                                <button
                                  className="btn btn-link p-0 m-0"
                                  onClick={(e) =>
                                    removeItem(
                                      e,
                                      item.pid,
                                      item.domain,
                                      item.whois,
                                      item.serviceid
                                    )
                                  }
                                >
                                  <img src={TrashIcon} alt="trash.svg" />
                                </button>
                              </>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                    {item.addon && (
                      <>
                        <tr>
                          <td colSpan={2}>
                            <div className="text-qw-primary">Addons</div>
                          </td>
                        </tr>
                        {/* Handle both array and object format */}
                        {Array.isArray(item.addon) ? (
                          // Array format (for Digital Signature and new implementation)
                          item.addon.map((addonItem, idx) => (
                            <tr key={idx}>
                              <td>
                                <div className="addon d-flex align-items-center gap-2">
                                  <span 
                                    style={{ 
                                      overflow: 'hidden', 
                                      textOverflow: 'ellipsis', 
                                      whiteSpace: 'nowrap',
                                      maxWidth: '200px',
                                      fontSize: '.875em'
                                    }}
                                    title={addonItem.name}
                                  >
                                    {addonItem.name}
                                  </span>
                                  {addonItem.isOneTime && (
                                    <span className="text-muted small" style={{ whiteSpace: 'nowrap', fontSize: '14px' }}>
                                      Sekali Bayar
                                    </span>
                                  )}
                                  {!addonItem.isOneTime && addonItem.multiplier && addonItem.multiplier > 1 && (
                                    <span className="text-muted small" style={{ whiteSpace: 'nowrap', fontSize: '14px' }}>
                                      {formatIDR(addonItem.pricePerUnit)} x {addonItem.multiplier} tahun
                                    </span>
                                  )}
                                </div>
                              </td>
                              <td className="text-end">
                                <small className="mb-0">
                                  {formatIDR(addonItem.price)}
                                </small>
                              </td>
                            </tr>
                          ))
                        ) : (
                          // Object format (for backward compatibility)
                          <tr>
                            <td>
                              <div className="addon d-inline">
                                {item.addon.addonName}
                              </div>
                            </td>
                            <td className="text-end">
                              <small className="mb-0">
                                {formatIDR(item.addon.price)}
                              </small>
                            </td>
                          </tr>
                        )}
                      </>
                    )}
                    {(item.vpsaddons && item.vpsaddons.length !== 0) ||
                      (item.configoptions && item.configoptions.length !== 0 && item.pid !== 1146 && item.pid !== 1157 && item.type !== "emailSuite") ||
                      (item.configoptions && item.configoptions.length !== 0 && item.pid >= 1160 && item.pid <= 1163) ||
                      (item.customfields && Array.isArray(item.customfields) && item.customfields.filter(field => !field.value.includes("Operating System - ")).length !== 0 && item.type === "server") ||
                      (item.vpsaddons && item.vpsaddons.some(addon => addon.input_name === "Immunify")) ? (
                      <>
                        <tr>
                          <td colSpan={2}>
                            <div className="text-qw-primary">Server addons</div>
                          </td>
                        </tr>
                        {item.configoptions && item.configoptions.length !== 0 && item.pid !== 1146 && item.pid !== 1157 && item.type !== "emailSuite" && !(item.pid >= 1160 && item.pid <= 1163) && (
                          <tr>
                            <td>
                              {item.configoptions?.map((option) => (
                                <div
                                  className="small text-truncate"
                                  key={option.id}
                                  title={option.name}
                                >
                                  {option.name}
                                </div>
                              ))}
                            </td>
                            <td className="text-end">
                              {item.configoptions &&
                                item.configoptions?.map((option) => (
                                  <div className="small" key={option.id}>
                                    {formatIDR(option.price)}
                                  </div>
                                ))}
                            </td>
                          </tr>
                        )}
                        {/* Config options khusus untuk VPS Custom (PID 1160-1163) */}
                        {item.configoptions && item.configoptions.length !== 0 && item.pid >= 1160 && item.pid <= 1163 && (
                          <tr>
                            <td>
                              <div className="small fw-semibold text-dark mb-1">Server Addons:</div>
                              {item.configoptions?.map((option) => (
                                <div
                                  className="small text-truncate ms-2"
                                  key={option.id}
                                  title={option.name}
                                >
                                  {option.name}
                                </div>
                              ))}
                            </td>
                            <td className="text-end">
                              <div className="small fw-semibold text-dark mb-1">&nbsp;</div>
                              {item.configoptions &&
                                item.configoptions?.map((option) => (
                                  <div className="small ms-2" key={option.id}>
                                    {formatIDR(option.price)}
                                  </div>
                                ))}
                            </td>
                          </tr>
                        )}
                        {item.customfields && Array.isArray(item.customfields) && item.customfields.filter(field => !field.value.includes("Operating System - ")).length !== 0 && item.type === "server" && (
                          <tr>
                            <td>
                              {item.customfields?.filter(field => !field.value.includes("Operating System - ")).map((field) => (
                                <div
                                  className="small text-truncate"
                                  key={field.id}
                                  title={field.value}
                                >
                                  {field.value}
                                </div>
                              ))}
                            </td>
                            <td className="text-end">
                              {item.customfields && Array.isArray(item.customfields) &&
                                item.customfields?.filter(field => !field.value.includes("Operating System - ")).map((field) => (
                                  <div className="small" key={field.id}>
                                    Selected
                                  </div>
                                ))}
                            </td>
                          </tr>
                        )}
                        {/* Operating System - dipisahkan dari Control Panel */}
                        {item.vpsaddons && item.vpsaddons.filter(addon => addon.input_name === "Operating System").length !== 0 && (
                          <tr>
                            <td>
                              <div className="small fw-semibold text-dark mb-1">Operating System:</div>
                              {item.vpsaddons
                                ?.filter(addon => addon.input_name === "Operating System")
                                .map((addonItem) => (
                                <div
                                  className="small text-truncate ms-2"
                                  key={addonItem.id}
                                  title={addonItem.name}
                                >
                                    {addonItem.name.split(" - ")[1] || addonItem.name}
                                </div>
                              ))}
                            </td>
                            <td className="text-end">
                              <div className="small fw-semibold text-dark mb-1">&nbsp;</div>
                              {item.vpsaddons
                                ?.filter(addon => addon.input_name === "Operating System")
                                .map((addonItem) => (
                                  <div className="small ms-2" key={addonItem.id}>
                                    {addonItem.billingcycle === "free" ||
                                      addonItem[item.billingcycle] ===
                                      "-1.00" ||
                                      addonItem[item.billingcycle] === "0.00" ||
                                      addonItem.price === 0
                                      ? "Free"
                                      : formatIDR(
                                        addonItem[item.billingcycle] || addonItem.price
                                      )}
                                  </div>
                                ))}
                            </td>
                          </tr>
                        )}
                        {/* Control Panel - dipisahkan dari Operating System */}
                        {item.vpsaddons && item.vpsaddons.filter(addon => addon.input_name === "Control Panel").length !== 0 && (
                          <tr>
                            <td>
                              <div className="small fw-semibold text-dark mb-1">Control Panel:</div>
                              {item.vpsaddons
                                ?.filter(addon => addon.input_name === "Control Panel")
                                .map((addonItem) => (
                                  <div
                                    className="small text-truncate ms-2"
                                    key={addonItem.id}
                                    title={addonItem.name}
                                  >
                                    {addonItem.name}
                                  </div>
                                ))}
                            </td>
                            <td className="text-end">
                              <div className="small fw-semibold text-dark mb-1">&nbsp;</div>
                              {item.vpsaddons
                                ?.filter(addon => addon.input_name === "Control Panel")
                                .map((addonItem) => (
                                  <div className="small ms-2" key={addonItem.id}>
                                    {addonItem.billingcycle === "free" ||
                                      addonItem[item.billingcycle] ===
                                      "-1.00" ||
                                      addonItem[item.billingcycle] === "0.00" ||
                                      addonItem.price === 0
                                      ? "Free"
                                      : formatIDR(
                                        addonItem[item.billingcycle] || addonItem.price
                                      )}
                                  </div>
                                ))}
                            </td>
                          </tr>
                        )}
                        {/* Immunify - dipisahkan dari addon lainnya */}
                        {item.vpsaddons && item.vpsaddons.filter(addon => addon.input_name === "Immunify").length !== 0 && (
                          <tr>
                            <td>
                              <div className="small fw-semibold text-dark mb-1">Immunify:</div>
                              {item.vpsaddons
                                ?.filter(addon => addon.input_name === "Immunify")
                                .map((addonItem) => (
                                  <div
                                    className="small text-truncate ms-2"
                                    key={addonItem.id}
                                    title={addonItem.name}
                                  >
                                    {addonItem.name}
                                  </div>
                                ))}
                            </td>
                            <td className="text-end">
                              <div className="small fw-semibold text-dark mb-1">&nbsp;</div>
                              {item.vpsaddons
                                ?.filter(addon => addon.input_name === "Immunify")
                                .map((addonItem) => (
                                  <div className="small ms-2" key={addonItem.id}>
                                    {addonItem.billingcycle === "free" ||
                                      addonItem[item.billingcycle] ===
                                      "-1.00" ||
                                      addonItem[item.billingcycle] === "0.00" ||
                                      addonItem.price === 0
                                      ? "Free"
                                      : formatIDR(
                                        addonItem[item.billingcycle] || addonItem.price
                                      )}
                                  </div>
                                ))}
                            </td>
                          </tr>
                        )}
                        {/* Display other VPS addons */}
                        {item.vpsaddons && item.vpsaddons.filter(addon => 
                          addon.input_name !== "Operating System" && 
                          addon.input_name !== "Control Panel" && 
                          addon.input_name !== "Immunify"
                        ).length > 0 && (
                          <tr>
                            <td>
                              <div className="small fw-semibold text-dark mb-1">Addons:</div>
                              {item.vpsaddons
                                .filter(addon => 
                                  addon.input_name !== "Operating System" && 
                                  addon.input_name !== "Control Panel" && 
                                  addon.input_name !== "Immunify"
                                )
                                .map((addonItem) => (
                                  <div
                                    className="small text-truncate ms-2"
                                    key={addonItem.id}
                                    title={addonItem.name}
                                  >
                                    {addonItem.name}
                                  </div>
                                ))}
                            </td>
                            <td className="text-end">
                              <div className="small fw-semibold text-dark mb-1">&nbsp;</div>
                              {item.vpsaddons
                                .filter(addon => 
                                  addon.input_name !== "Operating System" && 
                                  addon.input_name !== "Control Panel" && 
                                  addon.input_name !== "Immunify"
                                )
                                .map((addonItem) => (
                                  <div className="small ms-2" key={addonItem.id}>
                                    {addonItem.billingcycle === "free" ||
                                      addonItem[item.billingcycle] === "-1.00" ||
                                      addonItem[item.billingcycle] === "0.00" ||
                                      addonItem.price === 0
                                      ? "Free"
                                      : formatIDR(addonItem[item.billingcycle] || addonItem.price)}
                                  </div>
                                ))}
                            </td>
                          </tr>
                        )}
                      </>
                    ) : null}

                    {/* {item.domainForwarder && (
                      <PromoItem
                        label="Domain Forwarder"
                        price={formatIDR(0)}
                        onRemove={() => handleRemoveForwardDomain(item.domain)}
                        isFree={true}
                        description={item.domainForwarder}
                      />
                    )} */}
                  </tbody>
                ))}
                <tbody>
                  {promoCode.paymentGateway === "Gratis Payment Gateway" && (
                    <PromoItem
                      label="Addon Payment Gateway"
                      price=""
                      onRemove={removePaymentGateway}
                      isFree={true}
                    />
                  )}
                  {promoCode.customPromo === "Promo Kaos Tumbler" && (
                    <PromoItem
                      label="Gratis Kaos dan Tumbler (Termasuk Ongkir)"
                      price="Rp150.000"
                      onRemove={removeCustomPromo}
                    />
                  )}
                  {(domainBundle.onlineId || cartItems.some(item => item.domainForwarder)) && (
                    <PromoItem
                      label="Bundle Tambahan"
                      price={formatIDR(50000)}
                      onRemove={removeBundleItem}
                      isFree={true}
                      description={
                        <>
                          {domainBundle.onlineId && (
                            <small>
                              <span className="fw-bold text-muted">online.id/</span>
                              <span className="text-muted">{domainBundle.onlineId}</span>
                              {/* <span className="ms-2">
                                <s className="text-muted">{formatIDR(50000)}</s>
                                <span className="badge bg-warning ms-2">GRATIS!</span>
                              </span> */}
                            </small>
                          )}
                          {cartItems
                            .filter(item => item.domainForwarder)
                            .map((item, idx) => (
                              <div key={idx}>
                                <small>
                                  <span className="fw-bold text-muted">Forward Domain:</span><br />
                                  <span className="text-muted">{item.domainForwarder}</span>
                                  {/* <span className="ms-2">
                                    <s className="text-muted">{formatIDR(50000)}</s>
                                    <span className="badge bg-warning ms-2">GRATIS!</span>
                                  </span> */}
                                </small>
                              </div>
                            ))}
                        </>
                      }
                    />
                  )}
                  {(location.pathname === "/paymentmethod" ||
                    location.pathname === "/ordersummary") && (
                      <tr>
                        <td colSpan={2}>
                          <div className="d-flex justify-content-between">
                            <div className="fw-normal align-self-center">
                              Voucher dipakai
                            </div>
                            <div className="fst-italic px-2 d-flex align-items-center">
                              <span>
                                {promoCode.code ? (
                                  promoCode.code
                                ) : (
                                  <>
                                    <button
                                      className="btn btn-outline-qw-primary fw-bold rounded-5"
                                      onClick={promoModalHandler}
                                    >
                                      Pakai Voucher
                                    </button>
                                  </>
                                )}
                              </span>

                              {promoCode.code && (
                                <button
                                  className="btn btn-link p-0 m-0"
                                  onClick={removePromoHandle}
                                >
                                  <img
                                    src={deleteIcon}
                                    alt="delete.svg"
                                    className="ms-1"
                                  />
                                </button>
                              )}
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  <tr>
                    {paymentMethod || !isRemovePpn ? (
                      <td colSpan={2}>
                        <label className="mb-2">Pajak & Biaya Tambahan</label>
                        {paymentMethod ? (
                          <div className="d-flex mb-1 justify-content-between">
                            <div className="fw-bold d-flex">
                              Convenience Fee
                              <div className="d-flex align-self-center">
                                <OverlayTrigger
                                  placement={"right"}
                                  overlay={
                                    <Tooltip>
                                      Biaya admin pembayaran elektronik
                                    </Tooltip>
                                  }
                                >
                                  <span
                                    className="d-inline-block px-1 py-0 ms-1 fw-bold text-white"
                                    style={{
                                      backgroundColor: "#ee4d30",
                                      cursor: "pointer",
                                      borderRadius: "50%",
                                      fontSize: "10px",
                                    }}
                                  >
                                    ?
                                  </span>
                                </OverlayTrigger>
                              </div>
                            </div>

                            <div className="tax-price fw-bold">
                              + {formatIDR(parseInt(additionalFee) ?? 0)}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        {isRemovePpn ? (
                          ""
                        ) : (
                          <div className="d-flex justify-content-between">
                            <div className="fw-bold ml-3">
                              PPN 11%{" "}
                              <span className="text-muted">(12% * 11/12)</span>
                            </div>
                            <div className="tax-price fw-bold">
                              + {formatIDR(tax.price ?? 0)}
                            </div>
                          </div>
                        )}
                      </td>
                    ) : (
                      ""
                    )}
                  </tr>
                </tbody>
              </table>
            </>
          )}
        </div>

        {promoCode.code && promoCode.code === "HBDQWORDS" && (
          <Alert variant="success" className="my-3">
            <div>
              Selamat anda mendapatkan:
              <ul className="mb-0 mt-2">
                <li>
                  <span className="fw-bold">Cashback:</span> {formatIDR(18000)}
                </li>
              </ul>
              {promoCode.description && (
                <div className="mt-2">
                  <span className="fw-bold">Bonus:</span> {promoCode.description}
                </div>
              )}
              <div className="mt-3 pt-2 border-top">
                <span className="fw-bold">Total Anda berhasil berhemat sebesar: </span>
                <span className="fw-bold text-qw-primary">
                  {formatIDR(18000)}
                </span>
              </div>
            </div>
          </Alert>
        )}

        {cartItems.length > 0 &&
          (domainBundle.onlineId ||
            cartItems.some((item) => item.type === "whois") ||
            cartItems.some((item) => item.domainForwarder)) &&
          !promoCode.code && (
            <Alert variant="success" className="my-3">
              <div>
                Selamat kamu hemat sebesar{' '}
                <span className="fw-bold text-danger ms-1">
                  {formatIDR(
                    (domainBundle.onlineId ? 50000 : 0)
                    + (cartItems.filter((item) => item.type === "whois").length * 30000)
                    + (cartItems.some((item) => item.domainForwarder) ? 50000 : 0)
                  )}
                </span>
                !
              </div>
            </Alert>
          )}


        <hr className="mb-0" />

        <div className="mt-auto">
          <div
            className={`total-section ${cartItems.length === 0 ? "d-none" : "my-auto py-3"
              }`}
          >
            <div>
              <h5 className="mb-0">Total Tagihan</h5>
            </div>
            <div className="text-end">
              <h5
                className={`${isSummaryPage ? "text-success" : ""}`}
                id="total-cart"
              >
                {formatIDR(total)}
              </h5>
            </div>
          </div>

          {(location.pathname === "/paymentmethod" ||
            location.pathname === "/ordersummary") && (
              <div className="total-section mt-auto">
                <div>
                  <h6 className="fw-light mb-2 mt-2" style={{ fontSize: "14px" }}>
                    Metode Pembayaran
                  </h6>
                </div>
                <div className="text-end">
                  <h6 className="fw-bold mb-2 mt-2" style={{ fontSize: "14px" }}>
                    {paymentMethod?.label ?? "Belum Dipilih"}
                  </h6>
                </div>
              </div>
            )}

          {location.pathname === "/ordersummary" && (
            <>
              {
                cartItems.length > 0 &&
                paymentMethod && (
                  <div className="total-section mt-2">
                    <div>
                      <h6
                        className="fw-light mb-0"
                        style={{ fontSize: "14px" }}
                      >
                        Dengan Penawaran Internet
                      </h6>
                    </div>
                    <div className="text-end">
                      <h6 className="fw-bold" style={{ fontSize: "14px" }}>
                        {internetOfferStatus}
                      </h6>
                    </div>
                  </div>
                )}
            </>
          )}

          {location.pathname === "/ordersummary" && (
            <>
              {batasanBerlaku && domainConditional === true && (
                <>
                  {requirement.company === true && (
                    <>
                      {documentNpwp &&
                        showModal &&
                        !conditionalDomain.label &&
                        data_login &&
                        status_login === true &&
                        !conditionalDomain.isSkipAll && (
                          <ModalConditionalDomain
                            show={showModal}
                            onHide={handleCloseModal}
                            modalHandler={handleCloseModal}
                            tld={currentTld}
                            domain={currentDomain}
                            syarat={currentSyarat}
                            tldArr={tldArr}
                          />
                        )}
                    </>
                  )}

                  {requirement.company === false &&
                    data_login &&
                    status_login === true &&
                    !conditionalDomain.label &&
                    !conditionalDomain.isSkipAll && (
                      <>
                        {showModal && (
                          <ModalConditionalDomain
                            show={showModal}
                            onHide={handleCloseModal}
                            modalHandler={handleCloseModal}
                            tld={currentTld}
                            domain={currentDomain}
                            syarat={currentSyarat}
                            tldArr={tldArr}
                          />
                        )}
                      </>
                    )}

                  <ModalConfirmationDomain
                    show={showModalConfimation}
                    onHide={setShowModalConfirmation}
                    onClick={handlerCloseModalConfirmation}
                  />

                  <div className="total-section mt-2 mb-3">
                    <div>
                      <h6
                        className="fw-light mb-0"
                        style={{ fontSize: "14px" }}
                      >
                        Kelengkapan Domain Bersyarat
                      </h6>
                    </div>
                    <div className="text-end">
                      <h6 className="fw-bold" style={{ fontSize: "14px" }}>
                        {conditionalDomain?.label ?? "Belum Lengkap"}
                      </h6>
                    </div>
                  </div>
                </>
              )}
            </>
          )}

          {location.pathname === "/paymentmethod" && (
            <>
              <hr className="my-0" />
              <ToSCompanyCheckBox />
            </>
          )}

          {/* Pesan warning untuk hosting tanpa domain dengan billing cycle < 1 tahun */}
          {(() => {
            const hasShortTermHosting = cartItems
              .filter(item => item.type === "hostingaccount")
              .some(item =>
                item.billingcycle === "monthly" ||
                item.billingcycle === "quarterly" ||
                item.billingcycle === "semiannually"
              );

            return hasHosting && !hasDomain && !isExistingDomainValid && status_login && hasShortTermHosting;
          })() && (
              <div className="alert alert-warning my-2 text-center mb-3">
                <span className="fw-bold">
                  Produk hosting membutuhkan domain!
                </span>
              </div>
            )}

          <div className="d-grid">
            {!isSummaryPage && (
              <button
                className="btn btn-cta w-100"
                disabled={disabledNext}
                onClick={navigateRoute}
              >
                {location.pathname === "/paymentmethod" ? "Proses Pembayaran" : "Lanjutkan Pembayaran"}
              </button>
            )}
          </div>
          {isSummaryPage && <CheckoutButton />}
        </div>
      </div>



      <ModalPromoCode
        show={modalShow}
        onHide={() => setModalShow(false)}
        modalHandler={setModalShow}
      />

      <ModalLogin
        show={showLoginModal}
        onHide={() => setShowLoginModal(false)}
        onClickLogin={setShowLoginModal}
        onClickDaftar={() => {
          setShowLoginModal(false);
          setShowRegisterModal(true);
        }}
      />

      <ModalRegisterSimple
        show={showRegisterModal}
        onHide={() => setShowRegisterModal(false)}
        onClickDaftar={setShowRegisterModal}
        onClickLogin={() => {
          setShowRegisterModal(false);
          setShowLoginModal(true);
        }}
      />

      <ModalHostingNoDomain
        show={showHostingNoDomainModal}
        onHide={handleHostingNoDomainCancel}
        onConfirm={handleHostingNoDomainConfirm}
        onCancel={handleHostingNoDomainCancel}
        hostingPids={cartItems
          .filter(item => item.type === "hostingaccount")
          .map(item => item.pid)}
      />


    </>
  );
};

export default CheckoutTable;
